<div class="row">
    <nb-card class="custom ">


        <div class="mt-3 d-flex justify-content-between align-items-center">
            <div>
                <h4>Store Timings:</h4>
            </div>

            <div>
                <button type="submit" class="btn btn-primary btn-sm" (click)="onSave()">
                    Save
                </button>
                <button type="submit" class="btn btn-primary btn-sm" style="margin-left: 10px;" (click)="onClose()">
                    Close
                </button>
            </div>
        </div>

        <div class="container mt-4">

            <table class="table">
                <thead>
                    <tr>
                        <th colspan="4">Normal</th>
                        <!-- <th colspan="3">Holiday</th> -->
                    </tr>
                    <tr>
                        <th>Weekday</th>
                        <th>Open</th>
                        <th>Close</th>
                        <th></th>

                    </tr>
                </thead>
                <tbody>

                    <tr>
                        <td>Monday</td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.monday.open"></td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.monday.close"></td>
                        <td><label><input style="margin-top: 15px;" type="checkbox"
                                    [(ngModel)]="storeTimings.normal.monday.closed">
                                Closed</label></td>

                    </tr>

                    <tr>
                        <td>Tuesday</td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.tuesday.open"></td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.tuesday.close">
                        </td>
                        <td><label><input style="margin-top: 15px;" type="checkbox"
                                    [(ngModel)]="storeTimings.normal.tuesday.closed">
                                Closed</label></td>

                    </tr>

                    <tr>
                        <td>Wednesday</td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.wednesday.open">
                        </td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.wednesday.close">
                        </td>
                        <td><label><input style="margin-top: 15px;" type="checkbox"
                                    [(ngModel)]="storeTimings.normal.wednesday.closed">
                                Closed</label></td>

                    </tr>

                    <tr>
                        <td>Thursday</td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.thursday.open">
                        </td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.thursday.close">
                        </td>
                        <td><label><input style="margin-top: 15px;" type="checkbox"
                                    [(ngModel)]="storeTimings.normal.thursday.closed">
                                Closed</label></td>

                    </tr>

                    <tr>
                        <td>Friday</td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.friday.open"></td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.friday.close"></td>
                        <td><label><input style="margin-top: 15px;" type="checkbox"
                                    [(ngModel)]="storeTimings.normal.friday.closed">
                                Closed</label></td>

                    </tr>

                    <tr>
                        <td>Saturday</td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.saturday.open">
                        </td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.saturday.close">
                        </td>
                        <td><label><input style="margin-top: 15px;" type="checkbox"
                                    [(ngModel)]="storeTimings.normal.saturday.closed">
                                Closed</label></td>

                    </tr>

                    <tr>
                        <td>Sunday</td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.sunday.open"></td>
                        <td><input type="time" class="form-control" [(ngModel)]="storeTimings.normal.sunday.close"></td>
                        <td><label><input style="margin-top: 15px;" type="checkbox"
                                    [(ngModel)]="storeTimings.normal.sunday.closed">
                                Closed</label></td>

                    </tr>

                </tbody>
            </table>
        </div>

        <div class="container mt-4">

            <table class="table">
                <thead>
                    <tr>
                        <th colspan="6">Holidays</th>
                    </tr>
                    <tr>
                        <th rowspan="3">holiday</th>
                        <th rowspan="3">Date</th>
                        <th>Open</th>
                        <th>Close</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let holiday of storeTimings.holiday; let i = index">
                        <ng-select class="form-control" [(ngModel)]="storeTimings.holiday[i].holidayId"
                            placeholder="Select Holiday" (change)="onHolidaySelect($event, i)" [searchable]="false"
                            [clearable]="false">
                            <ng-option *ngFor="let holiday of holidays" [value]="holiday.id"
                                [disabled]="isHolidaySelected(holiday.id)">
                                {{ holiday.name }}
                            </ng-option>
                        </ng-select>

                        <td>
                            <input type="date" class="form-control" [(ngModel)]="storeTimings.holiday[i].date"
                                [readonly]="true" />
                        </td>

                        <td>
                            <input type="time" class="form-control" [(ngModel)]="holiday.open" />
                        </td>


                        <td>
                            <input type="time" class="form-control" [(ngModel)]="holiday.close" />
                        </td>


                        <td>
                            <label>
                                <input style="margin-top: 15px;" type="checkbox" [(ngModel)]="holiday.closed" />
                                Closed
                            </label>
                        </td>
                        <td>
                            <button type="button" class="btn btn-danger btn-sm" (click)="removeHoliday(i)">
                                <nb-icon icon="trash-outline"></nb-icon>
                            </button>
                        </td>
                    </tr>

                </tbody>
            </table>
            <div class="text-right" style="float: right;">
                <button type="button" class="btn btn-success btn-sm" (click)="addHoliday()"
                    [disabled]="storeTimings.holiday.length >= holidayCount">
                    <nb-icon icon="plus-outline"></nb-icon> Add Holiday
                </button>
            </div>
        </div>
    </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
    [fullScreen]="true">
    <p style="color: white">Loading...</p>
</ngx-spinner>